export default __webpack_public_path__ + "static/media/033-six.fa9142d1.svg";